// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useLocation } from "react-router-dom";
// import styles from "./ImportPhoneSip.module.css";
// import HeaderBar from "../HeaderBar/HeaderBar";
// import Loader from "../Loader/Loader";
// import PopUp from "../Popup/Popup";
// import decodeToken from "../../lib/decodeToken";
// import {
//   assignSipNumber,
//   deleteSipNumber,
//   fetchDashboardDetails,
//   getSipNumbers,
//   getSipSetupInfo,
//   importSipNumber,
//   unassignSipNumber,
//   updateSipNumber,
// } from "../../Store/apiStore";
// import { useDashboardStore } from "../../Store/agentZustandStore";

// const PROVIDERS = ["Twilio", "Telnyx", "Vonage", "Plivo", "Other"];
// const TRANSPORTS = ["TCP", "TLS", "UDP"];

// // Inline copy row used inside the setup steps — keeps the values compact.
// const CopyChip = ({ value, copied, onCopy }) => (
//   <span className={styles.chip}>
//     <code className={styles.chipValue}>{value}</code>
//     <button type="button" className={styles.chipBtn} onClick={onCopy}>
//       {copied ? "Copied" : "Copy"}
//     </button>
//   </span>
// );

// const EMPTY_FORM = {
//   provider_label: "Twilio",
//   phone_number: "",
//   termination_uri: "",
//   sip_username: "",
//   sip_password: "",
//   nickname: "",
//   transport: "TCP",
// };

// const ImportPhoneSip = () => {
//   const location = useLocation();
//   const { setHasFetched } = useDashboardStore();

//   // From an agent's More menu the target agent is fixed; standalone shows a picker.
//   const lockedAgentId = location?.state?.agentId || "";
//   const lockedAgentName = location?.state?.agentName || "";

//   const token = localStorage.getItem("token");
//   const userId = useMemo(() => decodeToken(token)?.id || "", [token]);

//   const [form, setForm] = useState(EMPTY_FORM);
//   const [selectedAgentId, setSelectedAgentId] = useState(lockedAgentId);
//   const [agents, setAgents] = useState([]);
//   const [numbers, setNumbers] = useState([]);
//   const [setupInfo, setSetupInfo] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);
//   const [copiedKey, setCopiedKey] = useState("");
//   const [showSetup, setShowSetup] = useState(false);
//   // Non-empty → the form is editing this already-imported number instead of adding one.
//   const [editingNumber, setEditingNumber] = useState("");

//   const [listLoading, setListLoading] = useState(true);
//   const [submitting, setSubmitting] = useState(false);
//   const [rowBusy, setRowBusy] = useState("");
//   const [fieldErrors, setFieldErrors] = useState({});

//   const [popupType, setPopupType] = useState("success");
//   const [popupMessage, setPopupMessage] = useState("");

//   const notify = (type, message) => {
//     setPopupType(type);
//     setPopupMessage(message);
//   };

//   const loadNumbers = useCallback(async () => {
//     if (!userId) return;
//     const res = await getSipNumbers(userId);
//     if (res?.success) setNumbers(res.data || []);
//   }, [userId]);

//   useEffect(() => {
//     let cancelled = false;

//     const load = async () => {
//       setListLoading(true);
//       const [info, dash] = await Promise.all([
//         getSipSetupInfo(),
//         userId ? fetchDashboardDetails(userId, token).catch(() => null) : Promise.resolve(null),
//       ]);
//       if (cancelled) return;

//       if (info?.success) setSetupInfo(info.data);

//       const list = dash?.agents || [];
//       setAgents(list);
//       // Standalone entry with exactly one agent → preselect it, nothing to pick.
//       if (!lockedAgentId && list.length === 1) setSelectedAgentId(list[0].agent_id);

//       await loadNumbers();
//       if (!cancelled) setListLoading(false);
//     };

//     load();
//     return () => {
//       cancelled = true;
//     };
//   }, [userId, token, lockedAgentId, loadNumbers]);

//   const setField = (key, value) => {
//     setForm((prev) => ({ ...prev, [key]: value }));
//     setFieldErrors((prev) => (prev[key] ? { ...prev, [key]: "" } : prev));
//   };

//   const copy = async (key, value) => {
//     try {
//       await navigator.clipboard.writeText(value);
//       setCopiedKey(key);
//       setTimeout(() => setCopiedKey(""), 1600);
//     } catch {
//       notify("failed", "Copy nahi ho paya. Please manually select karke copy karein.");
//     }
//   };

//   // Mirrors the server checks for instant feedback; the server still validates.
//   const validate = () => {
//     const errors = {};
//     const number = form.phone_number.replace(/[\s()\-.]/g, "");
//     const normalized = number.startsWith("+") ? number : `+${number}`;

//     // In edit mode the number is fixed and read-only, so only the trunk fields matter.
//     if (!editingNumber) {
//       if (!form.phone_number.trim()) {
//         errors.phone_number = "Phone number required hai.";
//       } else if (!/^\+[1-9]\d{6,14}$/.test(normalized)) {
//         errors.phone_number = "E.164 format me daalein, jaise +15595127812.";
//       }
//     }

//     const uri = form.termination_uri.trim();
//     if (!uri) {
//       errors.termination_uri = "Termination URI required hai.";
//     } else if (/sip\.retellai\.com/i.test(uri)) {
//       errors.termination_uri =
//         "Ye Retell ka SIP server hai. Apne carrier ka trunk URI daalein (jaise yourtrunk.pstn.twilio.com).";
//     }

//     setFieldErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleImport = async () => {
//     if (submitting) return;
//     if (!validate()) return;

//     setSubmitting(true);
//     const res = await importSipNumber({
//       ...form,
//       phone_number: form.phone_number.trim(),
//       termination_uri: form.termination_uri.trim(),
//       agent_id: selectedAgentId || undefined,
//     });
//     setSubmitting(false);

//     if (!res?.success) {
//       notify("failed", res?.message || "Number import nahi ho paya.");
//       return;
//     }

//     notify("success", res.message);
//     setForm(EMPTY_FORM);
//     // Agent's voip_numbers changed — force the dashboard to refetch.
//     if (selectedAgentId) setHasFetched(false);
//     await loadNumbers();
//   };

//   const startEdit = (n) => {
//     setEditingNumber(n.phone_number);
//     setFieldErrors({});
//     setShowPassword(false);
//     // Password is never sent back to the client — blank means "keep the saved one".
//     setForm({
//       // Anything the dropdown doesn't know (e.g. the server's "Custom" default) maps to Other.
//       provider_label: PROVIDERS.includes(n.provider_label) ? n.provider_label : "Other",
//       phone_number: n.phone_number,
//       termination_uri: n.termination_uri || "",
//       sip_username: n.sip_username || "",
//       sip_password: "",
//       nickname: n.nickname || "",
//       transport: n.transport || "TCP",
//     });
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const cancelEdit = () => {
//     setEditingNumber("");
//     setForm(EMPTY_FORM);
//     setFieldErrors({});
//   };

//   const handleSave = async () => {
//     if (submitting) return;
//     if (!validate()) return;

//     const payload = {
//       phone_number: editingNumber,
//       provider_label: form.provider_label,
//       termination_uri: form.termination_uri.trim(),
//       sip_username: form.sip_username,
//       transport: form.transport,
//       nickname: form.nickname,
//     };
//     // Only send a password when the user actually typed a new one.
//     if (form.sip_password) payload.sip_password = form.sip_password;

//     setSubmitting(true);
//     const res = await updateSipNumber(payload);
//     setSubmitting(false);

//     if (!res?.success) {
//       notify("failed", res?.message || "Update nahi ho paya.");
//       await loadNumbers();
//       return;
//     }

//     notify("success", res.message);
//     cancelEdit();
//     await loadNumbers();
//   };

//   const handleAssign = async (phone_number) => {
//     if (!selectedAgentId) {
//       notify("failed", "Pehle upar se ek agent select karein.");
//       return;
//     }
//     setRowBusy(phone_number);
//     const res = await assignSipNumber(phone_number, selectedAgentId);
//     setRowBusy("");

//     if (!res?.success) {
//       notify("failed", res?.message || "Assign nahi ho paya.");
//       return;
//     }
//     notify("success", res.message);
//     setHasFetched(false);
//     await loadNumbers();
//   };

//   const handleUnassign = async (phone_number) => {
//     setRowBusy(phone_number);
//     const res = await unassignSipNumber(phone_number);
//     setRowBusy("");

//     if (!res?.success) {
//       notify("failed", res?.message || "Unassign nahi ho paya.");
//       return;
//     }
//     notify("success", res.message);
//     setHasFetched(false);
//     await loadNumbers();
//   };

//   const handleDelete = async (n) => {
//     // Deleting kills live routing for this number, so confirm first.
//     const boundTo = n.agent_name || n.outbound_agent_id;
//     const ok = window.confirm(
//       `${n.phone_number} delete karein?\n\n` +
//         `• Retell se number delete ho jayega\n` +
//         (boundTo ? `• "${boundTo}" agent se unassign ho jayega\n` : "") +
//         `• Is number pe calls turant band ho jayengi\n\n` +
//         `Number aapke carrier ke paas hi rahega — dobara import kar sakte hain.`
//     );
//     if (!ok) return;

//     setRowBusy(n.phone_number);
//     const res = await deleteSipNumber(n.phone_number);
//     setRowBusy("");

//     if (!res?.success) {
//       notify("failed", res?.message || "Delete nahi ho paya.");
//       await loadNumbers();
//       return;
//     }
//     notify("success", res.message);
//     // The form was editing the row that just disappeared.
//     if (editingNumber === n.phone_number) cancelEdit();
//     setHasFetched(false);
//     await loadNumbers();
//   };

//   const assignTargetName =
//     lockedAgentName ||
//     agents.find((a) => a.agent_id === selectedAgentId)?.agentName ||
//     "";

//   return (
//     <div className={styles.page}>
//       <HeaderBar title="Import Phone" subtitle="Connect your own number" />

//       <div className={styles.container}>
//         {/* Collapsed by default — the form is the main job, these are reference values. */}
//         {setupInfo && (
//           <section className={styles.card}>
//             <button
//               type="button"
//               className={styles.discloseHeader}
//               onClick={() => setShowSetup((v) => !v)}
//               aria-expanded={showSetup}
//             >
//               <span className={styles.discloseIcon}>i</span>
//               <span className={styles.discloseText}>
//                 <span className={styles.discloseTitle}>Apne provider pe kya set karna hai</span>
//                 <span className={styles.discloseSub}>
//                   {showSetup ? "Chhupayein" : "5 steps · Origination URI dekhein"}
//                 </span>
//               </span>
//               <span className={showSetup ? styles.chevronOpen : styles.chevron} />
//             </button>

//             {showSetup && (
//               <ol className={styles.steps}>
//                 <li>
//                   Apne carrier (Twilio / Telnyx / Vonage) me ek <b>Elastic SIP Trunk</b> banayein.
//                 </li>
//                 <li>
//                   Trunk ke <b>Origination</b> me ye URI daalein:
//                   <CopyChip
//                     value={setupInfo.origination_uri}
//                     copied={copiedKey === "origination"}
//                     onCopy={() => copy("origination", setupInfo.origination_uri)}
//                   />
//                 </li>
//                 <li>
//                   Trunk ka <b>Termination URI</b> copy karke neeche form me paste karein.
//                 </li>
//                 <li>SIP credentials list banakar username / password neeche daalein.</li>
//                 <li>
//                   Apna number us trunk se associate karein, phir <b>Import &amp; Assign</b> karein.
//                 </li>
//                 <li className={styles.stepAdvanced}>
//                   Advanced — inbound webhook (sirf tab jab carrier maange):
//                   <CopyChip
//                     value={setupInfo.inbound_webhook_url}
//                     copied={copiedKey === "webhook"}
//                     onCopy={() => copy("webhook", setupInfo.inbound_webhook_url)}
//                   />
//                 </li>
//               </ol>
//             )}
//           </section>
//         )}

//         {/* Trunk details — same fields Retell's own SIP dialog asks for. */}
//         <section className={styles.card}>
//           <h3 className={styles.cardTitle}>
//             {editingNumber
//               ? `Update SIP settings — ${editingNumber}`
//               : "Connect to your number via SIP trunking"}
//           </h3>
//           {editingNumber && (
//             <p className={styles.cardHint}>
//               Save karte hi naye trunk details Retell pe apply ho jayengi. Agar Retell
//               inhe reject kare to purani settings wapas live rehti hain.
//             </p>
//           )}

//           <div className={styles.field}>
//             <label className={styles.label}>Provider</label>
//             <select
//               className={styles.input}
//               value={form.provider_label}
//               onChange={(e) => setField("provider_label", e.target.value)}
//             >
//               {PROVIDERS.map((p) => (
//                 <option key={p} value={p}>
//                   {p}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className={styles.field}>
//             <div className={styles.labelRow}>
//               <label className={styles.label}>Phone Number</label>
//               <span className={styles.labelNote}>Format: E.164</span>
//             </div>
//             <input
//               className={`${styles.input} ${fieldErrors.phone_number ? styles.inputError : ""}`}
//               placeholder="+15595127812"
//               value={form.phone_number}
//               // The number identifies the record — changing it means a new import.
//               disabled={!!editingNumber}
//               onChange={(e) => setField("phone_number", e.target.value)}
//             />
//             {fieldErrors.phone_number && (
//               <span className={styles.errorText}>{fieldErrors.phone_number}</span>
//             )}
//           </div>

//           <div className={styles.field}>
//             <label className={styles.label}>Termination URI</label>
//             <input
//               className={`${styles.input} ${fieldErrors.termination_uri ? styles.inputError : ""}`}
//               placeholder="yourtrunk.pstn.twilio.com (NOT Retell SIP server uri)"
//               value={form.termination_uri}
//               onChange={(e) => setField("termination_uri", e.target.value)}
//             />
//             {fieldErrors.termination_uri && (
//               <span className={styles.errorText}>{fieldErrors.termination_uri}</span>
//             )}
//           </div>

//           <div className={styles.field}>
//             <div className={styles.labelRow}>
//               <label className={styles.label}>SIP Trunk User Name</label>
//               <span className={styles.labelNote}>encouraged</span>
//             </div>
//             <input
//               className={styles.input}
//               placeholder="Enter SIP username"
//               autoComplete="off"
//               value={form.sip_username}
//               onChange={(e) => setField("sip_username", e.target.value)}
//             />
//           </div>

//           <div className={styles.field}>
//             <div className={styles.labelRow}>
//               <label className={styles.label}>SIP Trunk Password</label>
//               <span className={styles.labelNote}>
//                 {editingNumber ? "blank = keep existing" : "encouraged"}
//               </span>
//             </div>
//             <div className={styles.passwordWrap}>
//               <input
//                 className={styles.input}
//                 type={showPassword ? "text" : "password"}
//                 placeholder={
//                   editingNumber ? "Leave blank to keep saved password" : "Enter SIP password"
//                 }
//                 autoComplete="new-password"
//                 value={form.sip_password}
//                 onChange={(e) => setField("sip_password", e.target.value)}
//               />
//               <button
//                 type="button"
//                 className={styles.revealBtn}
//                 onClick={() => setShowPassword((v) => !v)}
//               >
//                 {showPassword ? "Hide" : "Show"}
//               </button>
//             </div>
//           </div>

//           <div className={styles.row}>
//             <div className={styles.field}>
//               <div className={styles.labelRow}>
//                 <label className={styles.label}>Nickname</label>
//                 <span className={styles.labelNote}>optional</span>
//               </div>
//               <input
//                 className={styles.input}
//                 placeholder="Enter nickname"
//                 value={form.nickname}
//                 onChange={(e) => setField("nickname", e.target.value)}
//               />
//             </div>

//             <div className={styles.field}>
//               <label className={styles.label}>Outbound Transport</label>
//               <select
//                 className={styles.input}
//                 value={form.transport}
//                 onChange={(e) => setField("transport", e.target.value)}
//               >
//                 {TRANSPORTS.map((t) => (
//                   <option key={t} value={t}>
//                     {t}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* Assignment is its own action per number, so it's hidden while editing. */}
//           <div className={styles.field} style={{ display: editingNumber ? "none" : "flex" }}>
//             <label className={styles.label}>Assign to agent</label>
//             {lockedAgentId ? (
//               <div className={styles.lockedAgent}>
//                 {lockedAgentName || lockedAgentId}
//                 <span className={styles.lockedTag}>selected</span>
//               </div>
//             ) : (
//               <select
//                 className={styles.input}
//                 value={selectedAgentId}
//                 onChange={(e) => setSelectedAgentId(e.target.value)}
//               >
//                 <option value="">Import only — assign later</option>
//                 {agents.map((a) => (
//                   <option key={a.agent_id} value={a.agent_id}>
//                     {a.agentName || a.agent_id}
//                   </option>
//                 ))}
//               </select>
//             )}
//             <span className={styles.helpText}>
//               Assign hote hi number inbound aur outbound dono ke liye is agent se
//               bind ho jayega.
//             </span>
//           </div>

//           <div className={styles.formActions}>
//             {editingNumber && (
//               <button
//                 className={styles.ghostBtn}
//                 onClick={cancelEdit}
//                 disabled={submitting}
//               >
//                 Cancel
//               </button>
//             )}
//             <button
//               className={styles.primaryBtn}
//               onClick={editingNumber ? handleSave : handleImport}
//               disabled={submitting}
//             >
//               {submitting ? (
//                 <span className={styles.btnLoading}>
//                   {editingNumber ? "Saving…" : "Importing…"} <Loader size={16} />
//                 </span>
//               ) : editingNumber ? (
//                 "Save Changes"
//               ) : selectedAgentId ? (
//                 `Import & Assign${assignTargetName ? ` to ${assignTargetName}` : ""}`
//               ) : (
//                 "Import Number"
//               )}
//             </button>
//           </div>
//         </section>

//         {/* Everything already imported on this account. */}
//         <section className={styles.card}>
//           <h3 className={styles.cardTitle}>Imported numbers</h3>

//           {listLoading ? (
//             <div className={styles.centerRow}>
//               <Loader size={22} />
//             </div>
//           ) : numbers.length === 0 ? (
//             <p className={styles.empty}>Abhi tak koi number import nahi kiya.</p>
//           ) : (
//             <ul className={styles.numberList}>
//               {numbers.map((n) => (
//                 <li key={n.id} className={styles.numberItem}>
//                   <div className={styles.numberMain}>
//                     <span className={styles.number}>{n.phone_number}</span>
//                     <span className={styles.numberMeta}>
//                       {n.provider_label} · {n.transport}
//                       {n.nickname ? ` · ${n.nickname}` : ""}
//                     </span>
//                     <span
//                       className={n.outbound_agent_id ? styles.badgeOn : styles.badgeOff}
//                     >
//                       {n.outbound_agent_id
//                         ? `Assigned → ${n.agent_name || n.outbound_agent_id}`
//                         : "Unassigned"}
//                     </span>
//                     {n.last_error && (
//                       <span className={styles.errorText}>Last sync failed</span>
//                     )}
//                   </div>

//                   <div className={styles.numberActions}>
//                     <button
//                       className={styles.ghostBtn}
//                       disabled={rowBusy === n.phone_number}
//                       onClick={() => startEdit(n)}
//                     >
//                       Edit
//                     </button>
//                     {n.outbound_agent_id ? (
//                       <button
//                         className={styles.ghostBtn}
//                         disabled={rowBusy === n.phone_number}
//                         onClick={() => handleUnassign(n.phone_number)}
//                       >
//                         Unassign
//                       </button>
//                     ) : (
//                       <button
//                         className={styles.ghostBtn}
//                         disabled={rowBusy === n.phone_number}
//                         onClick={() => handleAssign(n.phone_number)}
//                       >
//                         Assign
//                       </button>
//                     )}
//                     <button
//                       className={styles.dangerBtn}
//                       disabled={rowBusy === n.phone_number}
//                       onClick={() => handleDelete(n)}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </li>
//               ))}
//             </ul>
//           )}
//         </section>
//       </div>

//       {popupMessage && (
//         <PopUp
//           type={popupType}
//           message={popupMessage}
//           onClose={() => setPopupMessage("")}
//         />
//       )}
//     </div>
//   );
// };

// export default ImportPhoneSip;


import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ImportPhoneSip.module.css";
import HeaderBar from "../HeaderBar/HeaderBar";
import Loader from "../Loader/Loader";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import PopUp from "../Popup/Popup";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import decodeToken from "../../lib/decodeToken";
import {
  assignSipNumber,
  deleteSipNumber,
  fetchTeamDashboard,
  getSipNumbers,
  getSipSetupInfo,
  importSipNumber,
  unassignSipNumber,
  updateSipNumber,
} from "../../Store/apiStore";
import { useDashboardStore } from "../../Store/agentZustandStore";

// const PROVIDERS = ["Twilio", "Telnyx", "Vonage", "Plivo", "Other"];
const PROVIDERS = ["Twilio", "Telnyx"];
const TRANSPORTS = ["TCP", "TLS", "UDP"];

// Field limits — kept in sync with the same checks in sipPhoneController.
const LIMITS = {
  PHONE_MAX: 16, // "+" plus E.164's 15 digits
  URI_MAX: 100,
  SIP_USER_MIN: 3,
  SIP_PASS_MIN: 8, // carriers rarely issue a SIP secret shorter than this
  SIP_MAX: 30,
  NICKNAME_MAX: 50,
};

// "sip:host:5060;transport=tcp" → "host", so a pasted URI can be compared to ours.
const bareHost = (raw) =>
  String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/^sips?:/i, "")
    .replace(/[;:/].*$/, "");

// Inline copy row used inside the setup steps — keeps the values compact.
const CopyChip = ({ value, copied, onCopy }) => (
  <span className={styles.chip}>
    <code className={styles.chipValue}>{value}</code>
    <button type="button" className={styles.chipBtn} onClick={onCopy}>
      {copied ? "Copied" : "Copy"}
    </button>
  </span>
);

const EMPTY_FORM = {
  provider_label: "Twilio",
  phone_number: "",
  termination_uri: "",
  sip_username: "",
  sip_password: "",
  nickname: "",
  transport: "TCP",
};

const ImportPhoneSip = () => {
  const location = useLocation();
  const { setHasFetched } = useDashboardStore();

  // From an agent's More menu the target agent is fixed; standalone shows a picker.
  // Read the URL first — router state is dropped on refresh, and losing the lock
  // would silently give an admin the full picker on a screen opened for one agent.
  const lockedAgentId = useMemo(() => {
    const fromUrl = new URLSearchParams(location.search).get("agentId");
    return fromUrl || location?.state?.agentId || "";
  }, [location.search, location?.state]);

  const token = localStorage.getItem("token");
  const auth = useMemo(() => decodeToken(token) || {}, [token]);
  const userId = auth.id || "";

  // Company label per owner id, so a member of several companies can tell which
  // account an agent or number belongs to.
  const [ownerNames, setOwnerNames] = useState({});

  const [form, setForm] = useState(EMPTY_FORM);
  const [selectedAgentId, setSelectedAgentId] = useState(lockedAgentId);
  const [agents, setAgents] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [setupInfo, setSetupInfo] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [copiedKey, setCopiedKey] = useState("");
  const [showSetup, setShowSetup] = useState(false);
  // Non-empty → the form is editing this already-imported number instead of adding one.
  const [editingNumber, setEditingNumber] = useState("");
  // Controls the slide-in panel that hosts the add/edit form.
  const [drawerOpen, setDrawerOpen] = useState(false);
  // Row awaiting delete confirmation, or null.
  const [pendingDelete, setPendingDelete] = useState(null);

  const [listLoading, setListLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [rowBusy, setRowBusy] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});

  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const notify = (type, message) => {
    setPopupType(type);
    setPopupMessage(message);
  };

const loadNumbers = useCallback(async () => {
  if (!userId) return [];
  const res = await getSipNumbers(userId);
  const list = res?.success ? res.data || [] : [];
  setNumbers(list);
  return list;
}, [userId]);

useEffect(() => {
  let cancelled = false;

  const load = async () => {
    setListLoading(true);
    // fetchTeamDashboard covers both cases: it returns the user's own agents plus
    // every team owner's. fetchDashboardDetails alone queries one userId, so a team
    // member got an empty picker — their agents live under the owner's id.
    const [info, dash] = await Promise.all([
      getSipSetupInfo(),
      fetchTeamDashboard().catch(() => null),
    ]);
    if (cancelled) return;

    if (info?.success) setSetupInfo(info.data);

    const list = dash?.agents || [];
    setAgents(list);

    // "My Agents" plus one entry per company the user belongs to.
    const names = {};
    for (const g of dash?.groups || []) {
      if (g.ownerId) names[String(g.ownerId)] = g.ownerCompany || g.ownerName || "Company";
    }
    setOwnerNames(names);
    if (!lockedAgentId && list.length === 1) setSelectedAgentId(list[0].agent_id);

    const numbersList = await loadNumbers();
    if (cancelled) return;

    // Koi number import nahi hai — form seedha khol do.
    if (numbersList.length === 0) {
      openAddDrawer();
    }

    setListLoading(false);
  };

  load();
  return () => {
    cancelled = true;
  };
}, [userId, token, lockedAgentId, loadNumbers]);
  const setField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
    setFieldErrors((prev) => (prev[key] ? { ...prev, [key]: "" } : prev));
  };

  const copy = async (key, value) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(""), 1600);
    } catch {
      notify("failed", "Couldn't copy automatically. Please select and copy the value manually.");
    }
  };

  // Our own SIP host, from setup-info — belongs in Origination, never in Termination.
  const ourSipHost = useMemo(
    () => bareHost(setupInfo?.origination_uri),
    [setupInfo]
  );

  // Keeps a visible "+" on the number while the user types, and drops anything
  // that can't be part of an E.164 number so the field never holds junk.
  const setPhone = (raw) => {
    const digits = String(raw).replace(/\D/g, "").slice(0, LIMITS.PHONE_MAX - 1);
    setField("phone_number", digits ? `+${digits}` : "");
  };

  // Mirrors the server checks for instant feedback; the server still validates.
  const validate = () => {
    const errors = {};

    // In edit mode the number is fixed and read-only, so only the trunk fields matter.
    if (!editingNumber) {
      const number = form.phone_number.trim();
      if (!number) {
        errors.phone_number = "Phone number is required.";
      } else if (!number.startsWith("+")) {
        errors.phone_number = "Start with + and the country code, e.g. +15595127812.";
      } else if (!/^\+[1-9]\d{6,14}$/.test(number)) {
        errors.phone_number = "Enter 7 to 15 digits after the +, e.g. +15595127812.";
      }
    }

    const uri = form.termination_uri.trim();
    if (!uri) {
      errors.termination_uri = "Termination URI is required.";
    } else if (uri.length > LIMITS.URI_MAX) {
      errors.termination_uri = `Termination URI can be at most ${LIMITS.URI_MAX} characters.`;
    } else if (/\s/.test(uri)) {
      errors.termination_uri = "A trunk URI can't contain spaces.";
    } else if (ourSipHost && bareHost(uri) === ourSipHost) {
      errors.termination_uri =
        "That's our SIP server, not your termination URI. Enter your carrier's trunk URI instead (e.g. yourtrunk.pstn.twilio.com).";
    }

    // Credentials are optional, but a half-typed one is worse than none.
    const username = form.sip_username.trim();
    if (username && (username.length < LIMITS.SIP_USER_MIN || username.length > LIMITS.SIP_MAX)) {
      errors.sip_username = `SIP username must be ${LIMITS.SIP_USER_MIN} to ${LIMITS.SIP_MAX} characters.`;
    }

    const password = form.sip_password;
    if (password && (password.length < LIMITS.SIP_PASS_MIN || password.length > LIMITS.SIP_MAX)) {
      errors.sip_password = `SIP password must be ${LIMITS.SIP_PASS_MIN} to ${LIMITS.SIP_MAX} characters.`;
    }

    if (form.nickname.trim().length > LIMITS.NICKNAME_MAX) {
      errors.nickname = `Nickname can be at most ${LIMITS.NICKNAME_MAX} characters.`;
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Opens the drawer fresh, ready to add a brand-new number.
  const openAddDrawer = () => {
    setEditingNumber("");
    setForm(EMPTY_FORM);
    setFieldErrors({});
    setShowPassword(false);
    setDrawerOpen(true);
  };

  const startEdit = (n) => {
    setEditingNumber(n.phone_number);
    setFieldErrors({});
    setShowPassword(false);
    // Password is never sent back to the client — blank means "keep the saved one".
    setForm({
      // Anything the dropdown doesn't know (e.g. the server's "Custom" default) maps to Other.
      provider_label: PROVIDERS.includes(n.provider_label) ? n.provider_label : "Other",
      phone_number: n.phone_number,
      termination_uri: n.termination_uri || "",
      sip_username: n.sip_username || "",
      sip_password: "",
      nickname: n.nickname || "",
      transport: n.transport || "TCP",
    });
    setDrawerOpen(true);
  };

  const cancelEdit = () => {
    setEditingNumber("");
    setForm(EMPTY_FORM);
    setFieldErrors({});
  };

  const closeDrawer = () => {
    if (submitting) return;
    /*
     * Close only dismisses the drawer — it never navigates.
     *
     * This used to bounce to /fast-agent-detail whenever the list was empty,
     * on the theory that an empty list is nothing to look at. But the drawer
     * auto-opens on mount when the list is empty (see the load effect), so
     * between the two the user could never actually reach the empty page:
     * the only exit from the form was off the screen entirely. The empty
     * state is a usable screen — it has the hint and the + button.
     */
    cancelEdit();
    setDrawerOpen(false);
  };

  const handleImport = async () => {
    if (submitting) return;
    if (!validate()) return;

    setSubmitting(true);
    const res = await importSipNumber({
      ...form,
      phone_number: form.phone_number.trim(),
      termination_uri: form.termination_uri.trim(),
      agent_id: selectedAgentId || undefined,
    });
    setSubmitting(false);

    if (!res?.success) {
      notify("failed", res?.message || "Couldn't import the number.");
      return;
    }

    notify("success", res.message);
    setForm(EMPTY_FORM);
    setDrawerOpen(false);
    // Agent's voip_numbers changed — force the dashboard to refetch.
    if (selectedAgentId) setHasFetched(false);
    await loadNumbers();
  };

  const handleSave = async () => {
    if (submitting) return;
    if (!validate()) return;

    const payload = {
      phone_number: editingNumber,
      provider_label: form.provider_label,
      termination_uri: form.termination_uri.trim(),
      sip_username: form.sip_username,
      transport: form.transport,
      nickname: form.nickname,
    };
    // Only send a password when the user actually typed a new one.
    if (form.sip_password) payload.sip_password = form.sip_password;

    setSubmitting(true);
    const res = await updateSipNumber(payload);
    setSubmitting(false);

    if (!res?.success) {
      notify("failed", res?.message || "Couldn't save the update.");
      await loadNumbers();
      return;
    }

    notify("success", res.message);
    cancelEdit();
    setDrawerOpen(false);
    await loadNumbers();
  };

  const handleAssign = async (phone_number) => {
    if (!selectedAgentId) {
      notify("failed", "Select an agent above first.");
      return;
    }
    setRowBusy(phone_number);
    const res = await assignSipNumber(phone_number, selectedAgentId);
    setRowBusy("");

    if (!res?.success) {
      notify("failed", res?.message || "Couldn't assign the number.");
      return;
    }
    notify("success", res.message);
    setHasFetched(false);
    await loadNumbers();
  };

  const handleUnassign = async (phone_number) => {
    setRowBusy(phone_number);
    const res = await unassignSipNumber(phone_number);
    setRowBusy("");

    if (!res?.success) {
      notify("failed", res?.message || "Couldn't unassign the number.");
      return;
    }
    notify("success", res.message);
    setHasFetched(false);
    await loadNumbers();
  };

  // Deleting kills live routing for this number, so confirm in a modal first.
  const handleDelete = (n) => setPendingDelete(n);

  const confirmDelete = async () => {
    const n = pendingDelete;
    if (!n || rowBusy) return;

    setRowBusy(n.phone_number);
    const res = await deleteSipNumber(n.phone_number);
    setRowBusy("");
    setPendingDelete(null);

    if (!res?.success) {
      notify("failed", res?.message || "Couldn't delete the number.");
      await loadNumbers();
      return;
    }
    notify("success", res.message);
    // The form was editing the row that just disappeared.
    if (editingNumber === n.phone_number) {
      cancelEdit();
      setDrawerOpen(false);
    }
    setHasFetched(false);
   const updated = await loadNumbers();
  if (updated.length === 0) {
    openAddDrawer(); // list khaali ho gayi, form phir se kholo
  }
  };

  // Resolve the locked agent's name from the loaded list so it survives a refresh;
  // fall back to whatever the More menu passed, then the raw id.
  const lockedAgentName =
    agents.find((a) => a.agent_id === lockedAgentId)?.agentName ||
    location?.state?.agentName ||
    "";

  // Agents bucketed by company — an admin of several companies gets one long flat
  // list otherwise, with no way to tell whose agent is whose.
  const agentGroups = useMemo(() => {
    const byOwner = new Map();
    for (const a of agents) {
      const key = String(a.__ownerId || userId || "self");
      if (!byOwner.has(key)) {
        byOwner.set(key, {
          key,
          label: key === String(userId) ? "My agents" : ownerNames[key] || "Company",
          agents: [],
        });
      }
      byOwner.get(key).agents.push(a);
    }
    return [...byOwner.values()];
  }, [agents, ownerNames, userId]);

  const assignTargetName =
    lockedAgentName ||
    agents.find((a) => a.agent_id === selectedAgentId)?.agentName ||
    "";

  return (
    <div className={styles.page}>
      <div className={styles.headerWrap}>
        <HeaderBar
          title="Import Phone"
          subtitle="Connect your own number"
          backgroundColor="#6524EB"
          color="#ffffff"
        />
      </div>

      <div className={styles.container}>
        {/* Header is always visible so there's always a way to add the first number. */}
        <div className={styles.listHeaderRow}>
          <h3 className={styles.listHeaderTitle}>Imported Numbers</h3>
          <button
            type="button"
            className={styles.plusBtn}
            onClick={openAddDrawer}
            aria-label="Import a new number"
            title="Import a new number"
          >
            +
          </button>
        </div>

        {listLoading ? (
          <div className={styles.centerRow}>
            <Loader size={22} />
          </div>
        ) : numbers.length === 0 ? (
          <div className={styles.emptyCard}>
            <div className={styles.emptyIcon} aria-hidden="true">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 4l3 1 1.5 3-2 1.5a11 11 0 0 0 6 6l1.5-2 3 1.5L19 19a2 2 0 0 1-2 2A16 16 0 0 1 2 6a2 2 0 0 1 2-2z"
                  stroke="#6524EB"
                  strokeWidth="1.7"
                  strokeLinejoin="round"
                />
                <path d="M17 3v6M14 6h6" stroke="#6524EB" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
            </div>
            <h3 className={styles.emptyTitle}>No numbers imported yet</h3>
            <p className={styles.emptyText}>
              Bring your own number over SIP trunking and assign it to an agent
              for inbound and outbound calls.
            </p>
            <button type="button" className={styles.emptyCta} onClick={openAddDrawer}>
              <span aria-hidden="true" style={{ fontSize: 18, lineHeight: 1 }}>+</span>
              Import a number
            </button>
          </div>
        ) : (
          <section className={styles.card}>
            <ul className={styles.numberList}>
              {numbers.map((n) => (
                <li key={n.id} className={styles.numberItem}>
                  <div className={styles.numberMain}>
                    <span className={styles.number}>{n.phone_number}</span>
                    <span className={styles.numberMeta}>
                      {n.provider_label} · {n.transport}
                      {n.nickname ? ` · ${n.nickname}` : ""}
                      {/* Only worth showing when the user works across companies. */}
                      {agentGroups.length > 1 && n.userId !== userId
                        ? ` · ${ownerNames[String(n.userId)] || "Company"}`
                        : ""}
                    </span>
                    <span
                      className={n.outbound_agent_id ? styles.badgeOn : styles.badgeOff}
                    >
                      {n.outbound_agent_id
                        ? `Assigned → ${n.agent_name || n.outbound_agent_id}`
                        : "Unassigned"}
                    </span>
                    {n.has_error && (
                      <span className={styles.errorText}>Last sync failed</span>
                    )}
                  </div>

                  <div className={styles.numberActions}>
                    <button
                      className={styles.ghostBtn}
                      disabled={rowBusy === n.phone_number}
                      onClick={() => startEdit(n)}
                    >
                      Edit
                    </button>
                    {n.outbound_agent_id ? (
                      <button
                        className={styles.ghostBtn}
                        disabled={rowBusy === n.phone_number}
                        onClick={() => handleUnassign(n.phone_number)}
                      >
                        Unassign
                      </button>
                    ) : (
                      <button
                        className={styles.ghostBtn}
                        disabled={rowBusy === n.phone_number}
                        onClick={() => handleAssign(n.phone_number)}
                      >
                        Assign
                      </button>
                    )}
                    <button
                      className={styles.dangerBtn}
                      disabled={rowBusy === n.phone_number}
                      onClick={() => handleDelete(n)}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )}
      </div>

      {/* Slide-in panel: same form powers both "add" and "edit". */}
      {drawerOpen && (
        <div className={styles.drawerOverlay} onClick={closeDrawer}>
          <div
            className={styles.drawer}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={editingNumber ? "Update SIP settings" : "Import a number"}
          >
            <div className={styles.drawerHeader}>
              <span className={styles.drawerTitle}>
                {editingNumber
                  ? `Update SIP settings — ${editingNumber}`
                  : "Connect a number via SIP trunking"}
              </span>
              <button
                type="button"
                className={styles.drawerCloseBtn}
                onClick={closeDrawer}
                disabled={submitting}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <div className={styles.drawerBody}>
              {/* Collapsed by default — the form is the main job, these are reference values. */}
              {setupInfo && (
                <section className={styles.card}>
                  <button
                    type="button"
                    className={styles.discloseHeader}
                    onClick={() => setShowSetup((v) => !v)}
                    aria-expanded={showSetup}
                  >
                    <span className={styles.discloseIcon}>i</span>
                    <span className={styles.discloseText}>
                      <span className={styles.discloseTitle}>
                        What to set up with your provider
                      </span>
                      <span className={styles.discloseSub}>
                        {showSetup ? "Hide" : "5 steps · view Origination URI"}
                      </span>
                    </span>
                    <span className={showSetup ? styles.chevronOpen : styles.chevron} />
                  </button>

                  {showSetup && (
                    <ol className={styles.steps}>
                      <li>
                        Create an <b>Elastic SIP Trunk</b> with your carrier (Twilio /
                        Telnyx ).
                      </li>
                      <li>
                        Add this URI in the trunk's <b>Origination</b> settings:
                        <CopyChip
                          value={setupInfo.origination_uri}
                          copied={copiedKey === "origination"}
                          onCopy={() => copy("origination", setupInfo.origination_uri)}
                        />
                      </li>
                      <li>
                        Copy the trunk's <b>Termination URI</b> and paste it into the
                        form below.
                      </li>
                      <li>
                        Create a SIP credentials list and enter the username /
                        password below.
                      </li>
                      <li>
                        Associate your number with that trunk, then click{" "}
                        <b>Import &amp; Assign</b>.
                      </li>
                      {/* Inbound webhook — we set it ourselves on import, carriers don't need it.
                      <li className={styles.stepAdvanced}>
                        Advanced — inbound webhook (only if your carrier asks for
                        it):
                        <CopyChip
                          value={setupInfo.inbound_webhook_url}
                          copied={copiedKey === "webhook"}
                          onCopy={() => copy("webhook", setupInfo.inbound_webhook_url)}
                        />
                      </li> */}
                    </ol>
                  )}
                </section>
              )}

              {/* Trunk details the carrier needs to route calls to us. */}
              <section className={styles.card}>
                {editingNumber && (
                  <p className={styles.cardHint}>
                    Saving applies the new trunk details right away. If they're
                    rejected, your previous settings stay live.
                  </p>
                )}

                <div className={styles.field}>
                  <label className={styles.label}>Provider</label>
                  <select
                    className={styles.input}
                    value={form.provider_label}
                    onChange={(e) => setField("provider_label", e.target.value)}
                  >
                    {PROVIDERS.map((p) => (
                      <option key={p} value={p}>
                        {p}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <label className={styles.label}>Phone Number</label>
                    <span className={styles.labelNote}>Format: E.164</span>
                  </div>
                  <input
                    className={`${styles.input} ${fieldErrors.phone_number ? styles.inputError : ""}`}
                    placeholder="+15595127812"
                    inputMode="tel"
                    maxLength={LIMITS.PHONE_MAX}
                    value={form.phone_number}
                    // The number identifies the record — changing it means a new import.
                    disabled={!!editingNumber}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  {fieldErrors.phone_number && (
                    <span className={styles.errorText}>{fieldErrors.phone_number}</span>
                  )}
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <label className={styles.label}>Termination URI</label>
                    <span className={styles.labelNote}>
                      {form.termination_uri.length}/{LIMITS.URI_MAX}
                    </span>
                  </div>
                  <input
                    className={`${styles.input} ${fieldErrors.termination_uri ? styles.inputError : ""}`}
                    placeholder="yourtrunk.pstn.twilio.com (not our SIP server URI)"
                    maxLength={LIMITS.URI_MAX}
                    value={form.termination_uri}
                    onChange={(e) => setField("termination_uri", e.target.value)}
                  />
                  {fieldErrors.termination_uri && (
                    <span className={styles.errorText}>{fieldErrors.termination_uri}</span>
                  )}
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <label className={styles.label}>SIP Trunk User Name</label>
                    <span className={styles.labelNote}>
                      {LIMITS.SIP_USER_MIN}–{LIMITS.SIP_MAX} characters
                    </span>
                  </div>
                  <input
                    className={`${styles.input} ${fieldErrors.sip_username ? styles.inputError : ""}`}
                    placeholder="Enter SIP username"
                    autoComplete="off"
                    maxLength={LIMITS.SIP_MAX}
                    value={form.sip_username}
                    onChange={(e) => setField("sip_username", e.target.value)}
                  />
                  {fieldErrors.sip_username && (
                    <span className={styles.errorText}>{fieldErrors.sip_username}</span>
                  )}
                </div>

                <div className={styles.field}>
                  <div className={styles.labelRow}>
                    <label className={styles.label}>SIP Trunk Password</label>
                    <span className={styles.labelNote}>
                      {editingNumber
                        ? "blank = keep existing"
                        : `${LIMITS.SIP_PASS_MIN}–${LIMITS.SIP_MAX} characters`}
                    </span>
                  </div>
                  <div className={styles.passwordWrap}>
                    <input
                      className={`${styles.input} ${fieldErrors.sip_password ? styles.inputError : ""}`}
                      type={showPassword ? "text" : "password"}
                      placeholder={
                        editingNumber
                          ? "Leave blank to keep the saved password"
                          : "Enter SIP password"
                      }
                      autoComplete="new-password"
                      maxLength={LIMITS.SIP_MAX}
                      value={form.sip_password}
                      onChange={(e) => setField("sip_password", e.target.value)}
                    />
                    <button
                      type="button"
                      className={styles.revealBtn}
                      onClick={() => setShowPassword((v) => !v)}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                  {fieldErrors.sip_password && (
                    <span className={styles.errorText}>{fieldErrors.sip_password}</span>
                  )}
                </div>

                <div className={styles.row}>
                  <div className={styles.field}>
                    <div className={styles.labelRow}>
                      <label className={styles.label}>Nickname</label>
                      <span className={styles.labelNote}>
                        {form.nickname.length}/{LIMITS.NICKNAME_MAX}
                      </span>
                    </div>
                    <input
                      className={`${styles.input} ${fieldErrors.nickname ? styles.inputError : ""}`}
                      placeholder="Enter nickname"
                      maxLength={LIMITS.NICKNAME_MAX}
                      value={form.nickname}
                      onChange={(e) => setField("nickname", e.target.value)}
                    />
                    {fieldErrors.nickname && (
                      <span className={styles.errorText}>{fieldErrors.nickname}</span>
                    )}
                  </div>

                  <div className={styles.field}>
                    <label className={styles.label}>Outbound Transport</label>
                    <select
                      className={styles.input}
                      value={form.transport}
                      onChange={(e) => setField("transport", e.target.value)}
                    >
                      {TRANSPORTS.map((t) => (
                        <option key={t} value={t}>
                          {t}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Assignment is its own action per number, so it's hidden while editing. */}
                <div className={styles.field} style={{ display: editingNumber ? "none" : "flex" }}>
                  <label className={styles.label}>Assign to agent</label>
                  {lockedAgentId ? (
                    <div className={styles.lockedAgent}>
                      {lockedAgentName || lockedAgentId}
                      <span className={styles.lockedTag}>selected</span>
                    </div>
                  ) : (
                    <select
                      className={styles.input}
                      value={selectedAgentId}
                      onChange={(e) => setSelectedAgentId(e.target.value)}
                    >
                      <option value="">Import only — assign later</option>
                      {/* Grouped when the user belongs to more than one company. */}
                      {agentGroups.length > 1
                        ? agentGroups.map((g) => (
                            <optgroup key={g.key} label={g.label}>
                              {g.agents.map((a) => (
                                <option key={a.agent_id} value={a.agent_id}>
                                  {a.agentName || a.agent_id}
                                </option>
                              ))}
                            </optgroup>
                          ))
                        : agents.map((a) => (
                            <option key={a.agent_id} value={a.agent_id}>
                              {a.agentName || a.agent_id}
                            </option>
                          ))}
                    </select>
                  )}
                  <span className={styles.helpText}>
                    {agentGroups.length > 1
                      ? "The number is added to the company the selected agent belongs to, and bound to it for inbound and outbound calls."
                      : "Once assigned, this number is bound to this agent for both inbound and outbound calls."}
                  </span>
                </div>

                {/* Cancel hataya — drawer upar ke × se band hota hai. */}
                <AnimatedButton
                  label={
                    editingNumber
                      ? "Save Changes"
                      : selectedAgentId
                        ? `Import & Assign${assignTargetName ? ` to ${assignTargetName}` : ""}`
                        : "Import Number"
                  }
                  onClick={editingNumber ? handleSave : handleImport}
                  isLoading={submitting}
                  disabled={submitting}
                  positionType="relative"
                  width="100%"
                  bottom="0px"
                />
              </section>
            </div>
          </div>
        </div>
      )}

      <ConfirmModal
        show={!!pendingDelete}
        type="failed"
        title="Delete this number?"
        message={
          pendingDelete && (
            <>
              <b>{pendingDelete.phone_number}</b> will be disconnected
              {(pendingDelete.agent_name || pendingDelete.outbound_agent_id) && (
                <> and unassigned from {pendingDelete.agent_name || pendingDelete.outbound_agent_id}</>
              )}
              . Calls to it stop immediately. The number stays with your carrier, so you
              can import it again later.
            </>
          )
        }
        confirmText="Delete"
        cancelText="Keep it"
        showCancel
        isLoading={!!pendingDelete && rowBusy === pendingDelete.phone_number}
        onConfirm={confirmDelete}
        onClose={() => setPendingDelete(null)}
      />

      {popupMessage && (
        <PopUp
          type={popupType}
          message={popupMessage}
          onClose={() => setPopupMessage("")}
        />
      )}
    </div>
  );
};

export default ImportPhoneSip;